$(".custom-accordions-title").click(function(){
  $(this).toggleClass("active");
  $(this).next(".custom-accordions-content").slideToggle(300);
})
$(".custom-faq-title").click(function(){
  $(this).toggleClass("active");
  $(this).next(".custom-faq-text").slideToggle(300);
})
$(".custom-video-overlay").click(function(){
  $(this).fadeOut(300);
  $(this).parent().find(".custom-video-play").fadeOut(300);
  $(this).parent().find(".custom-video-vid").trigger("play");
})
$(document).on("click", ".custom-fp-product-atc, .custom-cart-drawer__upsell-product-atc", function(){
  let $this = $(this);
  $(this).addClass("active");
  let id = $(this).attr("data-id");
  let formData = {
    'items': [{
     'id': id,
     'quantity': 1
     }],
    sections: "cart-drawer,cart-icon-bubble"
   };
   fetch(window.Shopify.routes.root + 'cart/add.js', {
     method: 'POST',
     headers: {
       'Content-Type': 'application/json',
       'X-Requested-With': 'xmlhttprequest'
     },
     body: JSON.stringify(formData)
   })
   .then(response => {
     return response.json();
   })
   .then(res => {
    if(res.status){
      console.log(res);
    }
    else{
      $this.removeClass("active");
      // window.SLIDECART_UPDATE();
      // window.SLIDECART_OPEN();

      const cartParsedData = new DOMParser().parseFromString(res.sections['cart-drawer'], 'text/html');
      const cartBubbleParsedData = new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html');
      $("cart-drawer.drawer").removeClass("is-empty");
      $(".drawer__inner").html($(cartParsedData).find(".drawer__inner").html());
      $("#cart-icon-bubble").html($(cartBubbleParsedData).find(".shopify-section").html());
      $(".cart-count-bubble").trigger("click");
      if(document.querySelector(".custom-drawer-free--prod")){
        fetch(window.Shopify.routes.root + 'cart.js')
        .then(response => {
          return response.json();
        })
        .then((res) => {
          console.log("custom------cart", res);
          let vmax = parseFloat(document.querySelector(".custom-drawer-free--prod").getAttribute("data-max"));
          let vid = document.querySelector(".custom-drawer-free--prod").getAttribute("data-id");
          let alreadyAdded = false;
          for(let item of res.items){
            if(item.id == vid){
              alreadyAdded = true;
            }
          }
          if(res.total_price >= vmax && !alreadyAdded){
            let formData = {
              'items': [{
               'id': vid,
               'quantity': 1
               }],
              sections: "cart-drawer,cart-icon-bubble"
             };
             
             fetch(window.Shopify.routes.root + 'cart/add.js', {
               method: 'POST',
               headers: {
                 'Content-Type': 'application/json',
                 'X-Requested-With': 'xmlhttprequest'
               },
               body: JSON.stringify(formData)
             })
             .then(response => {
               return response.json();
             })
             .then(res => {
              if(res.status){
                console.log(res);
              }
              else{
                const cartParsedData = new DOMParser().parseFromString(res.sections['cart-drawer'], 'text/html');
                const cartBubbleParsedData = new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html');
                $("cart-drawer.drawer").removeClass("is-empty");
                $(".drawer__inner").html($(cartParsedData).find(".drawer__inner").html());
                $("#cart-icon-bubble").html($(cartBubbleParsedData).find(".shopify-section").html());
              }
             })
             .catch((error) => {
               console.error('Error:', error);
             });
          }
        });
      }
    }
   })
   .catch((error) => {
     console.error('Error:', error);
   })
   .finally(function(){
    $this.removeClass("active");
   });
})
$(".custom-video-slider-vid").click(function(){
  if($(this).hasClass("active")){
    $(this).trigger("pause");
    $(this).removeClass("active");
    $(this).parent().find(".custom-video-slider-play").show();
    $(this).parent().find(".custom-video-slider-pause").hide();
  }
  else{
    $(this).trigger("play");
    $(this).addClass("active");
    $(this).parent().find(".custom-video-slider-play").hide();
    $(this).parent().find(".custom-video-slider-pause").show();
  }
})
$(function(){
  updateSwiper();
  setTimeout(function(){
    if($("shopify-payment-terms").length > 0){
      let shoppay = $("shopify-payment-terms").closest("div").detach();
      if($(".product__info-wrapper .product-form").length > 0){
        $(".product__info-wrapper .product-form").closest("div").append(shoppay);
        $("shopify-payment-terms").show();
      }
    }
  }, 500)
  if($("#looxReviews").length > 0){
    $("#looxReviews").closest(".shopify-section").attr("style", "background: #F5F0FF");
  }
})
$(window).resize(function(){
  updateSwiper();
})
function updateSwiper(){
  if($(window).width() <= 749){
      $(".custom-video-slider-swiper").attr("space-between", "15");
      $(".custom-video-slider-swiper").each(function(){
        $(this).attr("slides-per-view", $(this).attr("data-mobile"));
      })
  }
  else{
    $(".custom-video-slider-swiper").attr("space-between", "30");
    $(".custom-video-slider-swiper").each(function(){
      $(this).attr("slides-per-view", $(this).attr("data-desktop"));
    })
  }
}

$(".custom-pdp-sticky-btn").click(function(){
  $(this).closest("form").find(".product-form__submit").trigger("click");
})

$(document).scroll(function() {
  if($(window).width() <= 749){
    var y = $(this).scrollTop();
    let offset = $(".product__info-wrapper .product-form__submit").offset().top + $(".product__info-wrapper .product-form__submit").height();
    if (y > offset) {
      $(".custom-pdp-sticky-btn").addClass("active");
    } else {
      $(".custom-pdp-sticky-btn").removeClass("active");
    }
  }
});


$(".custom-fp-product-atc-scroll").click(function(){
  if($(".custom--main--product").length > 0){
    $('html, body').animate({scrollTop: $(".custom--main--product").offset().top}, 1000);
  }
})